import React from "react";
import { Stack, TextField, Box, Typography, Button, FormControlLabel, Checkbox } from "@mui/material";
import PositionPanel from "./PositionPanel";

export default function ImagePanel({ el, updateEl, fileInputRef, onFileChange, isUploadingMedia = false, mode = "design" }) {
    const manualUrl =
        el.imageUrl ?? (typeof el.src === "string" && /^https?:\/\//i.test(el.src) ? el.src : "");

    return (
        <Stack spacing={1.5}>
            <TextField
                label="Nom du champ"
                value={el.fieldName || ""}
                onChange={e => updateEl(el.id, { fieldName: e.target.value })}
                size="small"
                fullWidth
                helperText="Ex: background, photo_produit"
            />

            {mode === "model" && (
                <FormControlLabel
                    sx={{ mt: -0.5 }}
                    control={
                        <Checkbox
                            size="small"
                            checked={!!el.fixed}
                            onChange={e => updateEl(el.id, { fixed: e.target.checked })}
                        />
                    }
                    label={<Typography variant="body2">Fixe (non editable dans le formulaire design)</Typography>}
                />
            )}

            <TextField
                label="URL de l'image"
                value={manualUrl}
                onChange={e => {
                    const nextUrl = e.target.value;
                    updateEl(el.id, { imageUrl: nextUrl, src: nextUrl });
                }}
                size="small"
                fullWidth
            />

            <Button disabled={isUploadingMedia} onClick={() => fileInputRef?.current?.click()}>
                {isUploadingMedia ? "Upload..." : "Uploader un media"}
            </Button>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*,video/*"
                style={{ display: "none" }}
                onChange={onFileChange}
            />

            <Box>
                <Typography variant="caption" color="text.secondary">
                    Opacité : {Math.round(el.opacity * 100)}%
                </Typography>
                <input
                    type="range"
                    min="0" max="1" step="0.05"
                    value={el.opacity}
                    onChange={e => updateEl(el.id, { opacity: Number(e.target.value) })}
                    style={{ width: "100%", marginTop: 4 }}
                />
            </Box>

            <PositionPanel el={el} updateEl={updateEl} />
        </Stack>
    );
}
